import Vue from 'vue';
import Translations from '@/utils/Translations';

Vue.filter('T', (term: string) => {
  return Translations.GetTranslation(term);
});

Vue.filter('EMPTY_FULL', (value: any) => {
  if (!value) {
    return 'Uppgift saknas';
  }
  return value;
});

Vue.filter('EMPTY', (value: any) => {
  if (!value) {
    return 'Saknas';
  }
  return value;
});

Vue.filter('ACCOUNTANT_FIRM', (value: any) => {
  if (value.slice(-3) === ' Ab') {
    return value.slice(0, value.length - 3) + ' AB';
  }
  return value;
});

Vue.filter('CAPITALIZE', (value: any) => {
  return value.slice(0, 1) + value.slice(1).toLowerCase();
});

Vue.filter('NAME', (value: any) => {
  const NameArr = value.split(',');
  if (NameArr.length === 1) {
    return NameArr[0];
  }
  return NameArr[1] + ' ' + NameArr[0];
});

// Nedan kommmer filter för automatiska kommentarer

Vue.filter('COMMENT_MARGIN', (value: any) => {
    if (value > 0.05) {
      return 'betydligt högre än';
    } else if (value > 0.01) {
      return 'högre än';
    } else if (value > 0.0025) {
      return 'lite högre än';
    } else if (value > 0.0004) {
      return 'i stort sett oförändrad mot';
    } else if (value < -0.05) {
      return 'väsentlig lägre än';
    } else if (value < -0.01) {
      return 'lägre än';
    } else if (value < -0.0025) {
      return 'lite lägre än';
    } else if (value < -0.0004) {
      return 'i stort sett oförändrad mot';
    } else {
      return 'samma som';
    }
  },
);

Vue.filter('COMMENT_CHANGE', (value: any) => {
    if (value > 0) {
      return 'ökade';
    } else if (value < 0) {
      return 'minskade';
    } else {
      return 'förblev oförändrade';
    }
  },
);

Vue.filter('COMMENT_VALUE', (value: any) => {
  if (value > 0) {
    return 'högre';
  } else if (value < 0) {
    return 'lägre';
  } else {
    return 'samma som';
  }
},
);

Vue.filter('POS_NEG', (value: any) => {
  if (value > 0) {
    return 'positivt';
  } else if (value < 0) {
    return 'negativt';
  } else {
    return 'oförändrat';
  }
},
);

Vue.filter('COUNT', (value: any) => {
  if (value === 1) {
    return 'ett';
  } else if (value === 2) {
    return 'två';
  } else if (value === 3) {
    return 'tre';
  } else if (value === 4) {
    return 'fyra';
  } else if (value === 5) {
    return 'fem';
  } else {
    return '';
  }
},
);


Vue.filter('IMPACT', (value: any) => {
  if (value > 0.2) {
    return 'Betydande';
  } else if (value > 0.04) {
    return 'Påtaglig';
  } else {
    return 'Begränsad';
  }
},
);


// Slut på filter för automatiska kommentarer

Vue.filter('DATE', (value: any) => {
  if (!value) {
    return '';
  }
  if (value.length === 8) {
    return `${value.substr(0, 4)}-${value.substr(4, 2)}-${value.substr(6, 2)}`;
  }
  return value;
});

Vue.filter('ORGNR', (value: any) => {
  if (!value) {
    return '';
  }
  if (value.length === 10) {
    return `${value.substr(0, 6)}-${value.substr(6, 10)}`;
  }
  return value;
});

Vue.filter('ZIP', (value: any) => {
  if (!value) {
    return '';
  }
  if (value.length === 5) {
    return `${value.substr(0, 3)} ${value.substr(3, 5)}`;
  }
  return value;
});

const ggr = (value: any) => {
  if (value === 0) {
    return '0';
  }
  if (!value) {
    return '';
  }
  value = value.toString();
  if (Number(value) > 999) {
    return '>999';
  } else if (Number(value) < -999) {
    return '<-999';
  }
  return Number(value).toLocaleString('sv-SE', {maximumFractionDigits: 0});
};
Vue.filter('GGR', ggr);

const d0 = (value: any) => {
  if (value === 0) {
    return '0';
  }
  if (!value) {
    return '';
  }
  value = value.toString();
  return Number(value).toLocaleString('sv-SE', {maximumFractionDigits: 0});
};
Vue.filter('D0', d0);

const d1 = (value: any) => {
  if (value === 0) {
    return '0';
  }
  if (!value) {
    return '';
  }
  value = value.toString();
  return Number(value).toLocaleString('sv-SE', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });
};
Vue.filter('D1', d1);

const d2 = (value: any) => {
  if (value === 0) {
    return '0';
  }
  if (!value) {
    return '';
  }
  value = value.toString();
  return Number(value).toLocaleString('sv-SE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};
Vue.filter('D2', d2);

Vue.filter('P', (value: any) => {
  if (!value && value !== 0) {
    return '-';
  }
  return (
    (value * 100).toLocaleString('sv-SE', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    }) + ' %'
  );
});

Vue.filter('P1', (value: any) => {
  if (!value && value !== 0) {
    return '';
  }
  return (
      (value * 100).toLocaleString('sv-SE', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
      }) + ' %'
  );
});

Vue.filter('P0', (value: any) => {
  if (!value && value !== 0) {
    return '';
  }
  return (
    (value * 100).toLocaleString('sv-SE', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }) + ' %'
  );
});

Vue.filter('tkr', (value: any) => {
  if (!value) {
    return '0';
  }
  return value.toString() + ' tkr';
});

Vue.filter('TKR', (value: any) => {
  if (!value) {
    return '0';
  }
  return d0(value) + ' tkr';
});

Vue.filter('MKR', (value: any) => {
  if (!value) {
    return '0';
  }
  value /= 1000;
  if (Math.abs(value) >= 10) {
    return d0(value) + ' mkr';
  } else {
    return d1(value) + ' mkr';
  }
});

Vue.filter('ABS', (value: any) => {
  if (!value) {
    return '0';
  }
  return Math.abs(Number(value));
});

Vue.filter('KR', (value: any) => {
  if (!value) {
    return '0';
  }
  const v = Number(value);
  if (Math.abs(v) >= 10000000) {
    return d0(v / 1000000) + ' mdr';
  }
  if (Math.abs(v) >= 1000000) {
    return d1(v / 1000000) + ' mdr';
  }
  if (Math.abs(v) >= 10000) {
    return d0(v / 1000) + ' mkr';
  }
  if (Math.abs(v) >= 1000) {
    return d1(v / 1000) + ' mkr';
  }
  return v + ' tkr';
});

Vue.filter('KRP', (value: any) => {
  if (!value) {
    return '0';
  }
  const v = Number(value);
  if (Math.abs(v) >= 10000000) {
    return d0(v / 1000000) + ' mdr';
  }
  if (Math.abs(v) >= 5000000) {
    return d1(v / 1000000) + ' mdr';
  }
  if (Math.abs(v) >= 1000000) {
    return d2(v / 1000000) + ' mdr';
  }
  if (Math.abs(v) >= 500000) {
    return d0(v / 1000) + ' mkr';
  }
  if (Math.abs(v) >= 10000) {
    return d1(v / 1000) + ' mkr';
  }
  if (Math.abs(v) >= 1000) {
    return d2(v / 1000) + ' mkr';
  }
  return d0(v) + ' tkr';
});

Vue.filter('TS', (value: any) => {
  if (!value) {
    return '';
  }
  return `${value.substr(0, 10)}`;
});

Vue.filter('TS2', (value: any) => {
  if (!value) {
    return '';
  }
  return `${value.substr(0, 16)}`;
});

Vue.filter('sign', (value: any) => {
  if (value > 0) {
    return `+${value}`;
  }
  return value;
});
